import React from "react";
import { appName } from "../../config";
import { useDesktopLargeMediaQuery } from "../../core/hooks/useMediaQuery";
import { IIndustry, ITopic } from "../../typings/filterEntities";
import FilterBar from "../FilterBar/FilterBar";
import Heading from "../Heading/Heading";
import { HomeIllustration } from "../Illustrations/Illustrations";
import styles from "./HomeHero.module.css";

interface IProps {
  filterBarRef?: React.RefObject<HTMLDivElement>;
  industries: IIndustry[];
  topics: ITopic[];
}

export default function HomeHero(props: IProps) {
  const isDesktopLargeViewport = useDesktopLargeMediaQuery();

  return (
    <section className={styles.root}>
      <div className={styles.illustration}>
        {isDesktopLargeViewport ? (
          <HomeIllustration width={540} height={472} />
        ) : (
          <HomeIllustration width={341} height={298} />
        )}
      </div>
      <div className={styles.content}>
        <Heading component="h1" variant="h1">
          {appName}
        </Heading>
        <p className={styles.copy}>
          Procedures to improve your maintenance, safety, and operations.
        </p>
        <div className={styles.filterBar}>
          <FilterBar {...props} location="homeHero" />
        </div>
      </div>
    </section>
  );
}
